import { Flame, Gift, Check } from "lucide-react";
import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";

interface DayReward {
  day: number;
  reward: string;
  claimed: boolean;
  current: boolean;
}

const weekRewards: DayReward[] = [
  { day: 1, reward: "5 XP", claimed: true, current: false },
  { day: 2, reward: "10 XP", claimed: true, current: false },
  { day: 3, reward: "20 XP", claimed: true, current: false },
  { day: 4, reward: "50 XP", claimed: false, current: true },
  { day: 5, reward: "100 XP", claimed: false, current: false },
  { day: 6, reward: "200 XP", claimed: false, current: false },
  { day: 7, reward: "🎁 Bonus", claimed: false, current: false },
];

export function DailyStreak() {
  const currentStreak = 3;
  const canClaim = true;

  return (
    <div className="p-5 rounded-xl bg-gradient-to-br from-orange-500/10 to-red-500/5 border border-orange-500/20">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <div className="w-10 h-10 rounded-lg bg-orange-500/20 flex items-center justify-center">
            <Flame className="w-5 h-5 text-orange-500" />
          </div>
          <div>
            <p className="font-semibold text-foreground">Daily Streak</p>
            <p className="text-xs text-muted-foreground">{currentStreak} days active</p>
          </div>
        </div>
        {canClaim && (
          <Button size="sm" className="bg-orange-500 hover:bg-orange-600 text-white">
            <Gift className="w-4 h-4 mr-1" />
            Claim
          </Button>
        )}
      </div>

      <div className="flex items-center gap-1 sm:gap-2">
        {weekRewards.map((day) => (
          <div
            key={day.day}
            className={cn(
              "flex-1 p-2 rounded-lg text-center transition-all",
              day.claimed && "bg-success/20 border border-success/30",
              day.current && "bg-orange-500/20 border-2 border-orange-500 animate-pulse",
              !day.claimed && !day.current && "bg-secondary/50 border border-border"
            )}
          >
            <p className="text-[10px] sm:text-xs text-muted-foreground mb-1">Day {day.day}</p>
            {day.claimed ? (
              <Check className="w-4 h-4 mx-auto text-success" />
            ) : (
              <p className="text-[10px] sm:text-xs font-medium text-foreground">{day.reward}</p>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
